export let TimelineGridEventPlaceholderDataAttributes = /*#__PURE__*/function (TimelineGridEventPlaceholderDataAttributes) {
  /**
   * Present when the event start date is in the past.
   */
  TimelineGridEventPlaceholderDataAttributes["started"] = "data-started";
  /**
   * Present when the event end date is in the past.
   */
  TimelineGridEventPlaceholderDataAttributes["ended"] = "data-ended";
  /**
   * Present when the event starts before the visible timeline range.
   */
  TimelineGridEventPlaceholderDataAttributes["startingBeforeEdge"] = "data-starting-before-edge";
  /**
   * Present when the event ends after the visible timeline range.
   */
  TimelineGridEventPlaceholderDataAttributes["endingAfterEdge"] = "data-ending-after-edge";
  return TimelineGridEventPlaceholderDataAttributes;
}({});